import axios from 'axios';
import config from '../config/config';
import { getAuthToken } from '../utils/token';

const getAuthConfig = () => {
    const token = getAuthToken();

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    };
};

/**
 * Get Production Plan Hours
 * @param {Array<string>} months
 */
export const getProductionPlanHours = async (months = []) => {
    return axios.post(
        `${config.API}/productiondispatchplan/getProductionPlanHours`,
        {
            months: months.join(','),
        },
        getAuthConfig()
    );
};